import IMask from 'imask';

const phones = document.querySelectorAll('.phone-mask');

for (const phone of phones) {
    IMask(phone, {
        mask: '+000(00) 000-00-00',
        lazy: true,
    });

    phone.setAttribute('placeholder', '+___(__) ___-__-__');
}

/**
 * where definitions are:

    0  - any digit
    a  - any letter
    *  - any char
    [] - make input optional
    {} - include fixed part in unmasked value
    `  - prevent symbols shift back
    \\ - fixed character (e.g. \\0).
 */
